<!--
 * @Author: niulin
 * @Description: TODO: 新版tab组件 不再使用任何控件 根据后续的业务需求 可以添加更多属性
 * @Date: 2025-04-09 10:21:28
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/componentsV2/base-cmps/tab/index.vue
-->
<template>
  <div :class="`tab-container ${customClass}`">
    <div :class="`tab-item ${tab[propsMap.key] === value ? 'active' : ''} ${disabled ? 'disabled' : ''}`" :style="{
      borderTopLeftRadius: showRadius && index === 0 ? '8px' : '0px',
      borderBottomLeftRadius: showRadius && index === 0 ? '8px' : '0px',
      borderTopRightRadius: showRadius && index === tabs.length - 1 ? '8px' : '0px',
      borderBottomRightRadius: showRadius && index === tabs.length - 1 ? '8px' : '0px',
      borderTop: showBorder ? `1px solid ${borderColor}` : 'none',
      borderBottom: showBorder ? `1px solid ${borderColor}` : 'none',
      borderRight: showBorder ? `1px solid ${borderColor}` : 'none',
      borderLeft: showBorder && index === 0 ? `1px solid ${borderColor}` : 'none',
      width: width,
      height: height,
    }" v-for="(tab, index) in tabs" :key="tab[propsMap.key]" @click="handleTabClick(tab[propsMap.key])">
      {{ tab[propsMap.label] }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'oner-tab-v2',
  props: {
    value: {
      type: String,
      default: 'MANUAL_INPUT',
    },
    // 传入宽度 默认100px
    width: {
      type: String,
      default: '123px',
    },
    // 传入高度 默认16px
    height: {
      type: String,
      default: '36px',
    },
    tabs: {
      type: Array,
      default: () => [],
    },
    //  传入是否国际化名称
    isInternational: {
      type: Boolean,
      default: true,
    },
    // 传入是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    // 属性映射
    propsMap: {
      type: Object,
      default: () => {
        return {
          label: 'label',
          key: 'value',
        };
      },
    },
    // 传入是否显示边框
    showBorder: {
      type: Boolean,
      default: true,
    },
    // 传入是否显示圆角
    showRadius: {
      type: Boolean,
      default: true,
    },
    // 支持传入自定义类名
    customClass: {
      type: String,
      default: '',
    },
    // 传入是否显示边框
    borderColor: {
      type: String,
      default: '#e5e6eb',
    },
  },
  data() {
    return {};
  },
  created() {
    // 初始默认选中,并触发更新
    const selectedValue = this.value || 'MANUAL_INPUT';
    this.$emit('input', selectedValue);
    this.tabs.forEach(tab => {
      tab[this.propsMap.label] = this.isInternational ? this.$t(tab[this.propsMap.label]) : tab[this.propsMap.label];
    });
  },
  methods: {
    handleTabClick(key) {
      if (this.disabled) {
        return;
      }
      this.$emit('input', key);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import './style/index.scss';
</style>
